/**
 * The name onboarding should show after a CV import.
 *
 * An email signup has no name of its own: the server stores the email's
 * local part (`abu1dhabi+333456`) as the account name, and the onboarding
 * provider captures it before the CV is uploaded. The import then saves the
 * CV's own name on the server, but "This Is You" kept the captured handle and
 * saved it back over the real name, so the CV header read like an email
 * address (owner testing, 2026-10-04).
 *
 * The CV's name wins only over that placeholder (empty, or the email's local
 * part); a name the user typed or the profile already held is kept.
 */
export function resolveImportedCvName(
  currentName: string,
  parsedName: string | null | undefined,
  accountEmail: string | null | undefined,
): string {
  const current = currentName.trim();
  const parsed = (parsedName ?? '').replace(/\s+/gu, ' ').trim();
  if (!parsed) return currentName;
  if (!current) return parsed;
  const localPart = (accountEmail ?? '').split('@')[0]?.trim().toLowerCase() ?? '';
  return localPart && current.toLowerCase() === localPart ? parsed : currentName;
}
